import { render, staticRenderFns } from "./COffline.vue?vue&type=template&id=caa2d68c&scoped=true"
import script from "./COffline.vue?vue&type=script&lang=js"
export * from "./COffline.vue?vue&type=script&lang=js"
import style0 from "./COffline.vue?vue&type=style&index=0&id=caa2d68c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa2d68c",
  null
  
)

export default component.exports